// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"8e5647ce","461":"4f413605","556":"79d91032","722":"ea812e45","881":"c644d0e9","930":"79d91032","953":"a909e77a"}[chunkId] + ".chunk.css";
};